export default {
    // a-form 表单会监听下面事件与值，到时候需要通过 change 事件传出新的值即可，v-decorator 会通过 change 事件接受新值
    model: {
        prop: 'vModelParam',
        event: 'change'
    },
    props: {
        vModelParam: {
            type: String
        }
    },
    watch: {
        // 监听当前值变化，及时提交给父组件
        vModelParam:{
            deep: true,
            immediate: true,
            handler: function (newValue) {
                let newValueFmt=newValue;
                if(newValueFmt!== this.localValue) {

                    this.localValue = newValueFmt;
                }
            }
        },
        localValue: {
            deep: true,
            immediate: true,
            handler: function (newValue) {
                this.$emit('change', newValue)
            }
        },

    },
    data () {
        return {
            localValue:undefined,
        }
    },
    method:{
    }
}